import React, { useState } from 'react';
import { NodeProps, NodeResizer } from 'reactflow';
import type { BoardGroupData } from '../../../types';
import { useBoardActions } from '../boardActions';
import './GroupNode.css';

const GroupNode: React.FC<NodeProps<BoardGroupData>> = ({ id, data, selected }) => {
  const { updateNodeData, readOnly } = useBoardActions();
  const [editingLabel, setEditingLabel] = useState(false);
  const [draftLabel, setDraftLabel] = useState(data.label || 'Group');

  const commitLabel = () => {
    setEditingLabel(false);
    const next = draftLabel.trim() || 'Group';
    if (next !== (data.label || 'Group')) updateNodeData(id, { label: next });
  };

  return (
    <>
      <NodeResizer
        isVisible={!!selected && !readOnly}
        minWidth={120}
        minHeight={100}
        lineClassName="board-resize-line"
        handleClassName="board-resize-handle"
      />
      <div
        className={`board-node board-group-node ${selected ? 'is-selected' : ''}`}
        style={{ background: data.color || 'rgba(99, 102, 241, 0.06)' }}
      >
        <div
          className="board-group-label"
          onDoubleClick={() => {
            if (!readOnly) {
              setDraftLabel(data.label || 'Group');
              setEditingLabel(true);
            }
          }}
        >
          {editingLabel && !readOnly ? (
            <input
              className="board-group-label-input nowheel nodrag"
              value={draftLabel}
              autoFocus
              onChange={(e) => setDraftLabel(e.target.value)}
              onBlur={commitLabel}
              onKeyDown={(e) => {
                if (e.key === 'Enter') commitLabel();
                if (e.key === 'Escape') {
                  setDraftLabel(data.label || 'Group');
                  setEditingLabel(false);
                }
              }}
            />
          ) : (
            <span>{data.label || 'Group'}</span>
          )}
        </div>
      </div>
    </>
  );
};

export default React.memo(GroupNode);
